<!--
 * @Author: wzh
 * @LastEditTime: 2022-09-21 17:09:57
 * @Description: 忘记密码
-->
<template>
	<div>
		<router-view />
	</div>
</template>

<script>
export default {
	name: "Forget",
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>

<style lang="scss" scoped></style>
